/**
 * Horocosmo GoKwik compat — hide Eurus drawer, patch renderAjax, refresh badge.
 * Does NOT intercept clicks, fetch, XHR, or MutationObserver (GoKwik must run unmodified).
 */
(function () {
  'use strict';

  if (window.__horocosmoAtcPerf) return;
  window.__horocosmoAtcPerf = true;
  window.__horocosmoGokwikCompatV = 3;

  function isGoKwikEnabled() {
    return window.__horocosmoIsGoKwik
      ? window.__horocosmoIsGoKwik()
      : !!(
          window.kwikCartActive ||
          typeof window.addItemtoCartFromForm === 'function' ||
          typeof window.gk_cart_domain === 'string' ||
          window.__gkConfigPromise
        );
  }

  function patchCartPreload() {
    if (!isGoKwikEnabled()) return;
    if (window.__horocosmoHideEurusCartContainer) {
      window.__horocosmoHideEurusCartContainer();
      return;
    }
    var container = document.getElementById('x-cart-drawer-container');
    if (!container) return;
    document.documentElement.classList.add('horocosmo-gokwik');
    container.style.setProperty('display', 'none', 'important');
    container.style.visibility = 'hidden';
    container.style.pointerEvents = 'none';
    container.setAttribute('aria-hidden', 'true');
    container.dataset.cartPreloaded = 'skip-gokwik';
  }

  function patchEurusCart() {
    if (!isGoKwikEnabled() || !window.Alpine || !Alpine.store('xHeaderMenu')) return;
    if (Alpine.store('xHeaderMenu')._horocosmoGokwikPatched) return;

    var origRender = Alpine.store('xHeaderMenu').renderAjax.bind(Alpine.store('xHeaderMenu'));
    Alpine.store('xHeaderMenu').renderAjax = function (el, id, element) {
      if (id === 'cart-drawer') return;
      return origRender(el, id, element);
    };
    Alpine.store('xHeaderMenu')._horocosmoGokwikPatched = true;

    if (Alpine.store('xMiniCart') && !Alpine.store('xMiniCart')._horocosmoGokwikPatched) {
      var store = Alpine.store('xMiniCart');
      var origOpen = store.openCart.bind(store);
      store.openCart = function () {
        if (isGoKwikEnabled()) return;
        return origOpen();
      };
      store._horocosmoGokwikPatched = true;
    }
  }

  patchCartPreload();
  document.addEventListener('DOMContentLoaded', patchCartPreload);
  document.addEventListener('alpine:init', function () {
    patchCartPreload();
    patchEurusCart();
  });
  document.addEventListener('alpine:initialized', function () {
    patchCartPreload();
    patchEurusCart();
  });

  var gokwikCheck = setInterval(function () {
    if (!isGoKwikEnabled()) return;
    patchCartPreload();
    patchEurusCart();
    if (window.kwikCartActive && typeof window.addItemtoCartFromForm === 'function') {
      clearInterval(gokwikCheck);
    }
  }, 200);
  setTimeout(function () { clearInterval(gokwikCheck); }, 15000);
})();
